<button class="btn-primary flex flex-col items-center justify-center relative cursor-pointer" [ngClass]="{ search: type === 'search', clip: type === 'clip', send: type === 'send', pink: changeColor}">
    <div class="inner-btn absolute bottom-0 w-full"></div>
    <img class="z-10 m-0" src="/assets/img/btn-icons/{{type}}.svg">
</button>